import * as Sentry from '@sentry/react';
import { isChunkReloadPending } from './utils/chunkReload';

// Get Sentry DSN from environment variable
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

// A function call keeps TS from narrowing MODE to 'prod' in the options below.
const isProdBuild = () => import.meta.env.MODE === 'prod';

if (!SENTRY_DSN) {
  console.warn('VITE_SENTRY_DSN is not set. Sentry will not be initialized.');
} else if (!isProdBuild()) {
  console.log(
    `Sentry is disabled outside the prod build (mode: ${import.meta.env.MODE}).`
  );
} else {
  console.log(
    `Sentry DSN is set. Initializing Sentry for environment: ${import.meta.env.MODE}`
  );
}

// Initialize Sentry only in the prod build
if (SENTRY_DSN && isProdBuild()) {
  Sentry.init({
    dsn: SENTRY_DSN,

    // Performance monitoring
    tracesSampleRate: 0.1, // 10% of transactions

    sendDefaultPii: true,
    integrations: [Sentry.replayIntegration()],

    // 100% of sessions in production, 0% in development
    replaysSessionSampleRate: import.meta.env.MODE === 'production' ? 1.0 : 0.0,
    replaysOnErrorSampleRate: 1.0,

    // Set environment
    environment: import.meta.env.MODE || 'development',

    // Enable debug mode in development
    debug: import.meta.env.DEV,

    // Configure beforeSend to filter out certain errors if needed
    beforeSend(event) {
      // A stale chunk is reloading the page. The error is expected and the
      // reloaded page reports its own errors (EMR-2435, ROGER-EMR-FRONTEND-9H).
      if (isChunkReloadPending()) return null;
      // Filter out certain errors if needed
      // For example, you might want to filter out network errors
      if (event.exception) {
        const exception = event.exception.values?.[0];
        if (exception?.type === 'NetworkError') {
          return null; // Don't send network errors
        }
      }
      return event;
    },
  });
}

export default Sentry;
